import React from 'react';

function DevicesIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <g>
        <path
          fill="#FF8A00"
          d="M20.51 12.222h-.546V3.25c.109-.528-.328-.95-.873-.95-.546 0-.982.422-.982.95v8.972H5.891V3.25c0-.528-.546-.95-.982-.95-.436 0-.982.422-.982.95v8.972h-.545C1.527 12.222 0 13.806 0 15.706v2.11c0 1.9 1.527 3.484 3.382 3.484h17.236c1.855 0 3.382-1.583 3.382-3.483v-2.111c-.11-1.9-1.636-3.484-3.49-3.484zm1.417 5.7c0 .845-.654 1.584-1.418 1.584H3.382c-.764 0-1.418-.74-1.418-1.584v-2.11c0-.845.654-1.584 1.418-1.584h17.236c.764 0 1.418.739 1.418 1.583v2.111h-.109zm-2.29-1.055c0 .844-.655 1.477-1.528 1.477s-1.527-.633-1.527-1.477c0-.845.654-1.478 1.527-1.478.873 0 1.527.633 1.527 1.478zm-12.982 0c0 .527-.437.95-.982.95H4.582c-.546 0-.982-.422-.982-.95s.436-.95.982-.95h1.09c.546 0 .983.422.983.95zm4.472 0c0 .527-.436.95-.982.95h-1.09c-.546 0-.982-.422-.982-.95s.436-.95.982-.95h1.09c.546 0 .982.422.982.95z"
        ></path>
      </g>
    </svg>
  );
}

export default DevicesIcon;
